import { render, staticRenderFns } from "./AppCustomFields.vue?vue&type=template&id=32059350"
import script from "./AppCustomFields.vue?vue&type=script&lang=ts"
export * from "./AppCustomFields.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports